import { Icon, Tooltip } from "@deligoo/ui"
import clsx from "clsx"
import dayjs from "dayjs"

import { TeamStats } from "@/types"
import { getWeatherIconName } from "@/utils"

import cls from "./WeatherIcon.module.scss"

type WeatherIconProps = {
  weather: TeamStats["weather"]
  className?: string
  fallback?: JSX.Element | string
  showTemperature?: boolean
}

export const WeatherIcon = ({ weather, className, fallback, showTemperature = true }: WeatherIconProps) => {
  if (!weather) {
    if (fallback) {
      if (typeof fallback === "string") return <span>{fallback}</span>
      return fallback
    }
    return null
  }

  return (
    <Tooltip content={`Ostatnia synchronizacja ${dayjs(weather.sync_at).fromNow()}`}>
      <div className={clsx(cls.weatherIcon, className)}>
        <Icon size="large" gutter="right" name={getWeatherIconName(weather.main, { withColor: true })} />
        {showTemperature && <span>{Math.round(weather.temperature)}℃</span>}
      </div>
    </Tooltip>
  )
}
